<template>
    <div class="post-card z-depth-2" data-aos="zoom-in">
      <router-link :to=" 'actualites/' + cardLink" class="box-link">
        <img v-if="cardImage" :src="cardImage" alt="" class="image-round z-depth-2">
        <h2 class="title">{{ cardTitle }}</h2>
        <div class="content" v-html="cardContent"></div>
      </router-link>
      <shared-buttons :redirect-url="cardLink" :text-content="stripTag(cardContent)"/>
    </div>
</template>
<script>
import SharedButtons from '@/components/socials/SharedButtons'
export default {
  components: {
    SharedButtons
  },
  data () {
    return {}
  },
  methods: {
    /**
     * Strip tag from string with html tag
     * @param string | ex: '<p>Bonjour</p>'
     * @return string | ex: 'Bonjour'
     */
    stripTag (html) {
      var tmp = document.createElement('DIV')
      tmp.innerHTML = html
      return tmp.textContent || tmp.innerText || ''
    }
  },
  props: ['cardTitle', 'cardContent', 'cardImage', 'cardLink']
}
</script>
<style lang="scss" scoped>
  @import 'PostCard';
</style>



// WEBPACK FOOTER //
// src/components/Posts/PostCard.vue